//axios api
import pharmaGoodApi from "@/lib/PharmaGoodApi";

export const getAll = async () => {
  try {
    const queryRoute = `/admin/hidden-offers`;

    const fetchRes = pharmaGoodApi.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const getOne = async (id) => {
  try {
    const queryRoute = `/admin/hidden-offers/${id}`;

    const fetchRes = pharmaGoodApi.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const update = async (id, body) => {
  try {
    const queryRoute = `/admin/hidden-offers/${id}`;

    const fetchRes = pharmaGoodApi.axios.patch(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const create = async (body) => {
  try {
    const queryRoute = `/admin/hidden-offers`;

    const fetchRes = pharmaGoodApi.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
